import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import LoadingIndicator from "../../utils/LoadingIndicator";
import ServiceAPI from "../../../service/ServiceAPI";
import { Container, Grid, Paper, Typography, Chip, Button } from "@material-ui/core";
import useErmaStyling from "../../../hooks/useErmaStyling";
import ErmaResponsiveGridItem from "../../utils/ErmaResponsiveGridItem";
import { TestResult } from "../../../enums/HoseEnum";
import ErmaResponsiveRecordGrid from "../../utils/ErmaResponsiveRecordGrid";
import HoseStatusChip from "./FragmentHoseStatus";
import Constants from "../../../utils/Constants";


const HoseHistory = () => {
  const params = useParams();
  const styling = useErmaStyling();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(true);
  const [hoseHistory, setHoseHistory] = useState(null);

  /**
   * 
   */
  useEffect(() => {
    ServiceAPI.HoseManagement().getHoseHistory(params.hoseId).then( (result) => {
    console.log(result);
      setHoseHistory(result);
      setShowLoading(false);
    });
  }, []);

  /**
   * 
   */
  const handleClick_btnBack = () => {
    navigate(Constants.RoutePath.HoseManagement.Listing);
  }

  /**
   * 
   * @returns 
   */
  const render = () => {
    if (showLoading) {
      return <div><LoadingIndicator isOpen={true} /></div>;
    }

    return (
      <Container >
        <Container className={styling.ermaStyles.container}>
          <Grid container>
            <Grid item xs={12} sm={10} className={styling.ermaStyles.gridTable_fieldAlignLeft}>
              <Typography className={styling.ermaStyles.sectionHeading}>
                Hose History
              </Typography>
            </Grid>
            <Grid item xs={12} sm={2} className={styling.ermaStyles.gridTable_fieldAlignRight}>
              <Button variant="contained" onClick={handleClick_btnBack}>
                Back
              </Button>
            </Grid>
          </Grid>
        </Container>

        { renderHoseDetails() }

        { renderHoseTests() }

        { renderHoseRepairs() }
        
      </Container>
    )
  }


  /**
   * Redners the hose specs section
   * @returns 
   */
  const renderHoseDetails = () => {
    return (
      <Container className={styling.ermaStyles.container}>
        <Paper elevation={1}>
          <Typography className={styling.ermaStyles.subHeading}>
            Hose Details
          </Typography>
        
          <ErmaResponsiveRecordGrid rowKey={ r => r.getId() } records={ [hoseHistory.getHose()] } >
            <ErmaResponsiveGridItem 
              label="Id" 
              xs={6} 
              sm={1} 
              element={ r => r.getId() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem 
              label="Name" 
              xs={6} 
              sm={3} 
              element={ r => r.getHoseName() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem 
              label="Diameter" 
              xs={6} 
              sm={1} 
              element={ r => (r.getDiameter() + "mm") }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem 
              label="Material" 
              xs={6} 
              sm={2} 
              element={ r => r.getMaterial() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem 
              label="Length" 
              xs={6} 
              sm={1} 
              element={ r => (r.getLengthM() + "m") }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem 
              label="Coupling" 
              xs={6} 
              sm={2} 
              element={ r => r.getCouplingType() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />

            <ErmaResponsiveGridItem 
              label="Status" 
              noXsLabel
              xs={6} 
              sm={2} 
              element={ (r) => { return <HoseStatusChip hose={r} classes={styling.ermaStyles} />} }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
          </ErmaResponsiveRecordGrid>
        </Paper>
      </Container>
    );
  }

  /**
   * Renders the Hose Test section
   * @returns 
   */
  const renderHoseTests = () => {
    return (
      <Container className={styling.ermaStyles.container}>
        <Paper elevation={1}>
          <Typography className={styling.ermaStyles.subHeading}>
            Pressure Test History
          </Typography>
          
          <ErmaResponsiveRecordGrid rowKey={ r => r.getId() } records={ hoseHistory.getTestRecords() } >
            <ErmaResponsiveGridItem 
              label="Test Date" 
              xs={6} 
              sm={2} 
              element={ r => r.getTestDate() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
    
            <ErmaResponsiveGridItem 
              label="Test Pressure" 
              xs={6} 
              sm={2} 
              element={ (r) => { return (r.getTestPressureKpa() + " kPa"); } }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
            
            <ErmaResponsiveGridItem 
              label="Tested By" 
              xs={6} 
              sm={2} 
              element={ r => r.getCreatedBy() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
            
            <ErmaResponsiveGridItem 
              label="Result"
              noXsLabel
              xs={6} 
              sm={2} 
              element={ (r) => {
                return <Chip color="primary" label={r.getResult()} className={ r.getResult() === TestResult.PASSED ? styling.ermaStyles.success : styling.ermaStyles.danger}/>
              }}
            />

            <ErmaResponsiveGridItem 
              label="Notes" 
              xs={12} 
              sm={4} 
              element={ r => r.getNotes() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignLeft]
              }}
            />
          </ErmaResponsiveRecordGrid>
        </Paper>
      </Container>
    );
  }


  const renderHoseRepairs = () => {
    return (
      <Container className={styling.ermaStyles.container}>
        <Paper elevation={1}>
          <Typography className={styling.ermaStyles.subHeading}>
            Hose Repair History
          </Typography>
          
          <ErmaResponsiveRecordGrid rowKey={ r => r.getId() } records={ hoseHistory.getRepairRecords() } >
            <ErmaResponsiveGridItem 
              label="Repair Date" 
              xs={6} 
              sm={2} 
              element={ r => r.getTestDate() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
    
            <ErmaResponsiveGridItem 
              label="Repair By"
              xs={6} 
              sm={2} 
              element={ r => r.getTestDate() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}

            />

            <ErmaResponsiveGridItem 
              label="Outcome" 
              noXsLabel
              xs={6} 
              sm={2} 
              element={ (r) => {
                return <Chip color="primary" label={r.getResult()} className={ r.getResult() === TestResult.PASSED ? styling.ermaStyles.success : styling.ermaStyles.danger}/>
              }}
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
            
            <ErmaResponsiveGridItem 
              label="Repair Type" 
              xs={6} 
              sm={2} 
              element={ r => r.getCreatedBy() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignCenter]
              }}
            />
            
            

            <ErmaResponsiveGridItem 
              label="Details" 
              xs={12} 
              sm={4} 
              element={ r => r.getNotes() }
              classes={{
                xs: [styling.ermaStyles.gridTable_fieldAlignLeft],
                sm: [styling.ermaStyles.gridTable_fieldAlignLeft]
              }}
            />
          </ErmaResponsiveRecordGrid>
        </Paper>
      </Container>
    );
  }

  return render();
}

export default HoseHistory;